define('databag',['jquery', 'hooks', 'jquery-iecors', 'domReady!'], function($, Hooks) {

  var Databag = {};

  var userId = null,
    profileUrl = '//profile.ngpvan.com/profile/',
    identityUrl = '//profile.ngpvan.com/identity';

  function start() {
    try {
      if ($('#ngpvanevents-form-detail-van-form').length <= 0) {
        return ;
      }

      $.support.cors = true;
      getUserId();
    }
    catch (e) {
    }
  }

  function getUserId() {
    $.ajax({
      url: identityUrl,
      dataType: 'jsonp'
    }).done(function (id) {
      userId = id;
      Hooks.dataBagGotUserId(id);
      getProfile(id);
    });
  }

  function getProfile() {
    if (!userId) {
      return ;
    }

    $.ajax({
      cache: false,
      type: 'GET',
      dataType: 'json',
      url: profileUrl + userId,
      timeout: 2000,
      success: gotBag
    });

    $('#ngpvanevents-form-detail-van-form').submit(postIntercept);
  }

  function gotBag(fieldValues) {
    Hooks.dataBagGotBag(fieldValues);
    autofill(fieldValues);
  }

  var field_names = {
    'edit-signup-first-name': ['first_name', 'FirstName'],
    'edit-signup-last-name': ['last_name', 'LastName'],
    'edit-signup-email': ['email', 'EmailAddress'],
    'edit-signup-phone': ['phone', 'Phone'],
    'edit-signup-zip': ['zip', 'PostalCode']
  };

  function autofill(fields) {
    if (typeof fields !== 'object' || !fields) {
      return ;
    }

    for (var field_id in field_names) {
      var val = '';
      var ngpvanevents_prop_name = field_names[field_id][0];
      var nvtag_prop_name = field_names[field_id][1];
      var nvtag_prop_name_with_value = nvtag_prop_name + '.Value';
      if (fields.ngpvanevents && fields.ngpvanevents[ngpvanevents_prop_name]) {
        val = fields.ngpvanevents[ngpvanevents_prop_name];
      }
      else if (fields[nvtag_prop_name]) {
        val = fields[nvtag_prop_name];
      }
      else if (fields[nvtag_prop_name_with_value]) {
        val = fields[nvtag_prop_name_with_value];
      }

      if (val) {
        var selector = '#' + field_id;
        $(selector).val(val);
      }
    }

    Hooks.dataBagAutoFilledForm();
  }

  function postIntercept(evt) {
    evt.preventDefault();

    Hooks.dataBagBeginsSubmit();

    var resubmit = function() {
      Hooks.dataBagPostedBag();
      evt.target.submit();
    }

    if (!form_is_valid()) {
      return ;
    }

    var ngpvanevents_field_values = {};
    var post_to_databag = false;

    for (var field_id in field_names) {
      var selector = '#' + field_id;
      var val = $(selector).val();

      if (!val) {
        continue;
      }

      var ngpvanevents_prop_name = field_names[field_id][0];
      ngpvanevents_field_values[ngpvanevents_prop_name] = val;
      post_to_databag = true;
    }

    if (post_to_databag) {
      var data_to_post = { 'ngpvanevents': ngpvanevents_field_values };

      Hooks.dataBagBeginsPostBag(userId, data_to_post);

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: profileUrl + userId,
        timeout: 2000,
        data: data_to_post,
        success: resubmit,
        error: resubmit
      });
    }

    return true;
  }

  // sort of dumb... but we don't want invalid data going into databag
  // ideally we should reuse the js validation on $.validator
  // unfortunately the $ that has .validator is different than the $ that
  // comes wrapped in ngpvanevents
  // ultimately we can solve this issue by using nvtag in place of our custom form
  // this function is a temporary fix
  function form_is_valid() {
    if (!$('#edit-signup-first-name').val() || !$.trim($('#edit-signup-first-name').val())) { 
      return false;
    }

    if (!$('#edit-signup-last-name').val() || !$.trim($('#edit-signup-last-name').val())) { 
      return false;
    }

    var email = $('#edit-signup-email').val();
    if (!email ||
      !email.match(/^([a-zA-Z0-9]+[_\.\-\']?)+@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/)) {

      return false;
    }
    

    var phone_number = $('#edit-signup-phone').val();
    if (!phone_number) {
      return false;
    }

    phone_number = phone_number.replace(/[^\d]+/gi, '');
    if (phone_number.length <= 9 ||
      !phone_number.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/)) {

      return false;
    }

    var postalcode = $('#edit-signup-zip').val();
    if (!postalcode || !postalcode.match(/(^\d{5}$)/)) {
      return false;
    }


    return true;
  }

  Databag.init = function() { start(); }
  return Databag;

});

